import React from "react";

import Drugstore_product from "./Drugstore_product";
import deliver_icon from "../assets/deliver_icon.png";

const Drugstore_item = (props) => {
  let isDrug = false;
  props.shopData.forEach((element) => {
    if (element.is_lek) isDrug = true;
  });

  const free_margin = isDrug
    ? props.shopData[0].kurier_free_margin
    : props.shopData[0].ship_free_margin;
  return (
    <article className="message is-success ">
      <div>
        <div className="message-body accordion  ">
          <a href={props.shopData[0].shop_url}>{props.shopData[0].shop_name}</a>

          <strong className="price tag tooltip is-info is-medium">
            <span className="tooltiptext ">
              Suma wszystkich produktów bez kosztów wysyłki
            </span>
            {props.priceSum.toFixed(2)} zł
          </strong>
        </div>
        <section className="">
          {props.shopData.map((item, key) => {
            let quantity = 0;
            if (
              props.tagData.length > 0 &&
              props.tagData.length === props.shopData.length
            ) {
              let selectedTags = props.tagData.filter((tag) => {
                return tag.guid === item.guid;
              });
              if (selectedTags.length === 1)
                quantity = selectedTags[0].quantity;
            }
            return (
              <Drugstore_product
                key={key}
                quantity={quantity}
                description={item.description}
                price={item.value}
                is_lek={item.is_lek}
                ext_url_short={item.ext_url_short}
              />
            );
          })}

          <div className=" field is-grouped tags is-grouped-multiline panel-block  control  has-addons">
            <strong className=" tag tooltip is-link  is-small">
              <span className="tooltiptext">
                Koszty Dostawy, koszt może być zależny od zawartości koszyka
              </span>
              Dostawa od {props.shipmentCost.toFixed(2)}
            </strong>
            <strong className="  tag is-warning tooltip is-small  ">
              <span className="tooltiptext">
                Kwota od której jest darmowa wysyłka
              </span>
              darmowa od {free_margin}
            </strong>

            {props.shopData[0].ship_url && (
              <>
                <strong className="  tag is-link tooltip is-small  ">
                  <span className="tooltiptext">Szczegóły dostawy</span>
                  <a href={props.shopData[0].ship_url}> Szczegóły » </a>
                </strong>
              </>
            )}
          </div>
        </section>
      </div>
    </article>
  );
};

export default Drugstore_item;
